import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import CatalogoCatProgramatica from "../../catalogos/catalogoCategoriaProgramatica";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import CatalogoProveedorPresupuesto from "../../catalogos/catalogoProveedorm";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentaBancarias";
import axios from "axios";

export const ImpEjeFinanciera2 = (props) => {
  // --- UTILIDADES ---
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");
  const anioActual = new Date().getFullYear();
  const fechaHoy = new Date().toISOString().split('T')[0];
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const post = JSON.parse(localStorage.getItem("post"));
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [modoBanco, setModoBanco] = useState('seleccionar');
  const [modoProveedor, setModoProveedor] = useState('seleccionar');
  const [tiposRetencion, setTiposRetencion] = useState([]); // Para almacenar los tipos de retención
  // --- REFS PRINCIPALES ---
  // Radio buttons para banco
  const radioBancoSelectRef = useRef();
  const radioBancoIndividualRef = useRef();

  // Proveedor
  const provCodigoRef = useRef();
  const provNombreRef = useRef();

  // Banco
  const bancoCodigoRef = useRef();
  const bancoNombreRef = useRef();

  // Tipo de Ordenes (Resumen Check + Radios)
  const radioTipoOrdTodasRef = useRef();
  const radioTipoOrdPresupRef = useRef();
  const radioTipoOrdFinanRef = useRef();
  const radioTipoOrdTercerosRef = useRef();
  const checkResumenRef = useRef(); // Checkbox "Resumen"

  // --- NUEVOS REFS AGREGADOS ---
  // Para reporte 121 (Todas/Por Trasladar/Trasladadas)
  const radioProveedorTodasRef = useRef(); // Radio "Todas" en reporte 121
  const radioProveedorPorTrasladarRef = useRef(); // Radio "Por Trasladar" en reporte 121
  const radioProveedorTrasladadasRef = useRef(); // Radio "Trasladadas" en reporte 121

  // Para reporte 124 (Todas/Por Enterar/Enteradas)
  const radioRetencionTodasRef = useRef(); // Radio "Todas" en reporte 124
  const radioRetencionPorEnterarRef = useRef(); // Radio "Por Enterar" en reporte 124
  const radioRetencionEnteradasRef = useRef(); // Radio "Enteradas" en reporte 124

  // Select de Tipo de Retención
  const selectTipoRetencionRef = useRef();

  // Para reporte 121 (radio buttons específicos)
  const radioReporte121TodasRef = useRef();
  const radioReporte121PorTrasladarRef = useRef();
  const radioReporte121TrasladadasRef = useRef();

  // Para reporte 124 (radio buttons específicos)
  const radioReporte124TodasRef = useRef();
  const radioReporte124PorEnterarRef = useRef();
  const radioReporte124EnteradasRef = useRef();

  const [mostrar3, setMostrar3] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  // --- REFS UTILIZADOS ---
  const txt1 = useRef(); // Sector
  const txt2 = useRef(); // Prog
  const txt3 = useRef(); // SubProg
  const txt4 = useRef(); // Proy
  const txt5 = useRef(); // Act
  const btnCat = useRef();

  const fechaDesdeRef = useRef();
  const fechaHastaRef = useRef();
  const tipoCompromisoRef = useRef();

  // --- FUNCIÓN AUXILIAR PARA FORMATEAR FECHAS ---
  const formatearFecha = (fechaInput) => {
    if (!fechaInput) return null;
    // La fecha viene en formato YYYY-MM-DD del input type="date"
    const partes = fechaInput.split('-');
    if (partes.length === 3) {
      // Retorna en formato DD-MM-YYYY como espera el backend
      return partes[2] + '-' + partes[1] + '-' + partes[0];
    }
    return fechaInput;
  };

  const seleccionarRegistros = () => {

    let campos = '*';
    let nomtab = 'tiporetencion';
    let orden = 'idproveedor';

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios.get(endpoint, {
      headers: {
        "x-access-token": `${token}`,
        'Content-Type': 'application/json'

      },
    }).then(function (response) {

      if (response.status == 200) {
        console.log("Tipos de Retención obtenidos:", response.data);
        setTiposRetencion(response.data);
      }

    }).catch(function (error) {





    })

  }




  // --- FUNCIÓN IMPRIMIR ---
  const imprimir = () => {
    let idEfi = idefiscal;
    let tit = titulo[props.reporte] || 'Reporte';
    let org = post.nombreorg;

    // --- REPORTE 120: Retenciones Declaradas (tiporep 22 de Java) ---
    if (props.reporte === 120) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición SQL (igual que en Java)
        let sql = " Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Nombre del reporte Jasper (Adm_RetencDecl en Java)
        let fileName = "Adm_RetencDecl";

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql.trim()) +
          "&TIT_RANGO=" + encodeURIComponent(sql2) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 121: Retenciones por Trasladar/Trasladadas a Ctas Fondo de Terceros (tiporep 49 de Java) ---
    else if (props.reporte === 121) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición base de fecha
        let sql = " Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Condición de proveedor
        let sql3 = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current && provCodigoRef.current.value.trim() !== "") {
          sql3 = "t.idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql3 = "true";
        }

        // Condición de tipo de retención
        let sql4 = "";
        let posret = selectTipoRetencionRef.current ? selectTipoRetencionRef.current.value : "";
        if (!posret || posret === "") {
          sql4 = "true"; // Todas las retenciones
        } else {
          sql4 = "t.idtiporetencion = " + posret;
        }

        // Condición según el radio button seleccionado (Por Trasladar/Trasladadas)
        let sql5 = "", sql6 = "", sql7 = "";

        // Determinar qué radio está seleccionado (Todas/Por Trasladar/Trasladadas)
        if (radioProveedorTodasRef.current && radioProveedorTodasRef.current.checked) {
          sql5 = "true";
          sql6 = "true";
          sql7 = "Listado General de Retenciones";
        } else if (radioProveedorPorTrasladarRef.current && radioProveedorPorTrasladarRef.current.checked) {
          sql5 = "ret_idche IS NULL";      // Por Trasladar (sin cheque asignado)
          sql6 = "idchequeemitido IS NULL";
          sql7 = "Listado de Retenciones por Trasladar";
        } else if (radioProveedorTrasladadasRef.current && radioProveedorTrasladadasRef.current.checked) {
          sql5 = "ret_idche IS NOT NULL";  // Trasladadas (con cheque asignado)
          sql6 = "idchequeemitido IS NOT NULL";
          sql7 = "Listado de Retenciones Trasladadas";
        } else {
          // Por defecto, todas
          sql5 = "true";
          sql6 = "true";
          sql7 = "Listado General de Retenciones";
        }

        // Combinar condiciones de proveedor y tipo de retención
        sql3 = sql3 + " AND " + sql4;

        // Nombre del reporte Jasper (Adm_RetencTraslProve en Java)
        let fileName = "Adm_RetencTraslProve";

        // Determinar el nombre del archivo según la selección
        let nomreporte = "";
        if (sql7.includes("por Trasladar")) {
          nomreporte = "Listado_General_de_Retenciones_por_Trasladar";
        } else if (sql7.includes("Trasladadas")) {
          nomreporte = "Listado_General_de_Retenciones_Trasladadas";
        } else {
          nomreporte = "Listado_General_de_Retenciones";
        }

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" +
          "reporte=" + fileName +
          "&efiscal=" + idEfi +
          "&CONDICION=" + encodeURIComponent(sql.trim()) +
          "&CONDICION1=" + encodeURIComponent(sql3) +
          "&TIT_RANGO=" + encodeURIComponent(sql2) +
          "&CONDICION2=" + encodeURIComponent(sql5) +
          "&CONDICION3=" + encodeURIComponent(sql6) +
          "&TIT_CRITERIO=" + encodeURIComponent(sql7) +
          "&HASTA=" + encodeURIComponent("'" + val3 + "'") +
          "&NOMBRE_REPORTE=" + encodeURIComponent(nomreporte) +
          "&tit=" + encodeURIComponent(tit) +
          "&org=" + encodeURIComponent(org),
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 122: Retenciones por Enterar por Proveedor (Fondo de Terceros) (tiporep 47 de Java) ---
    else if (props.reporte === 122) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Validar que se haya seleccionado un proveedor si el modo es 'seleccionar'
        if (modoProveedor === 'seleccionar' && (!provCodigoRef.current || provCodigoRef.current.value.trim() === "")) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe seleccionar un proveedor",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición base de fecha
        let sql = " Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Condición de proveedor
        let sql3 = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current && provCodigoRef.current.value.trim() !== "") {
          sql3 = "t.idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql3 = "true";
        }

        // Condición de tipo de retención
        let sql4 = "";
        let posret = selectTipoRetencionRef.current ? selectTipoRetencionRef.current.value : "";
        if (!posret || posret === "" || posret === "0") {
          sql4 = "true"; // Todas las retenciones
        } else {
          sql4 = "t.idtiporetencion = " + posret;
        }

        // Combinar condiciones
        sql3 = sql3 + " AND " + sql4;

        // Nombre del reporte Jasper (Adm_RetencPendProve en Java)
        let fileName = "Adm_RetencPendProve";

        // Parámetros adicionales específicos para este reporte
        let params = {
          reporte: fileName,
          efiscal: idEfi,
          CONDICION: encodeURIComponent(sql.trim()),
          CONDICION1: encodeURIComponent(sql3),
          TIT_RANGO: encodeURIComponent(sql2),
          FECFIN: encodeURIComponent("'" + val3 + "'"),
          espiritu: espiritu,
          tit: encodeURIComponent(tit),
          org: encodeURIComponent(org)
        };

        // Construir URL con parámetros
        let urlParams = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" + urlParams,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 123: Retenciones Enteradas por Proveedor (Fondo de Terceros) (tiporep 54 de Java) ---
    else if (props.reporte === 123) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Validar que se haya seleccionado un proveedor si el modo es 'seleccionar'
        if (modoProveedor === 'seleccionar' && (!provCodigoRef.current || provCodigoRef.current.value.trim() === "")) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe seleccionar un proveedor",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición base de fecha
        let sql = " Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Condición de proveedor
        let sql3 = "";
        if (modoProveedor === 'seleccionar' && provCodigoRef.current && provCodigoRef.current.value.trim() !== "") {
          sql3 = "t.idproveedor = " + provCodigoRef.current.value.trim();
        } else {
          sql3 = "true";
        }

        // Condición de tipo de retención
        let sql4 = "";
        let posret = selectTipoRetencionRef.current ? selectTipoRetencionRef.current.value : "";
        if (!posret || posret === "" || posret === "0") {
          sql4 = "true"; // Todas las retenciones
        } else {
          sql4 = "t.idtiporetencion = " + posret;
        }

        // Combinar condiciones
        sql3 = sql3 + " AND " + sql4;

        // Nombre del reporte Jasper (Adm_RetencEnteradaProve en Java)
        let fileName = "Adm_RetencEnteradaProve";

        // Parámetros para el reporte
        let params = {
          reporte: fileName,
          efiscal: idEfi,
          CONDICION: encodeURIComponent(sql.trim()),
          CONDICION1: encodeURIComponent(sql3),
          TIT_RANGO: encodeURIComponent(sql2),
          FECFIN: encodeURIComponent("'" + val3 + "'"),
          espiritu: espiritu,
          tit: encodeURIComponent(tit),
          org: encodeURIComponent(org)
        };

        // Construir URL con parámetros
        let urlParams = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" + urlParams,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 124: Retenciones Realizadas - Agrupadas por Bancos (tiporep 45 de Java) ---
    else if (props.reporte === 124) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Validar que se haya seleccionado un banco si el modo es 'seleccionar'
        if (modoBanco === 'seleccionar' && (!bancoCodigoRef.current || bancoCodigoRef.current.value.trim() === "")) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe seleccionar un banco",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición base de fecha
        let sql = " RET_FECHA Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Condición de banco
        let banco = "";
        if (modoBanco === 'seleccionar' && bancoCodigoRef.current && bancoCodigoRef.current.value.trim() !== "") {
          banco = " AND IDCUENTABANCARIA = " + bancoCodigoRef.current.value.trim();
        } else {
          banco = " AND TRUE";
        }

        // Condición de estatus de retención
        let sql3 = "";
        if (radioRetencionTodasRef.current && radioRetencionTodasRef.current.checked) {
          sql3 = " AND true ";
        } else if (radioRetencionPorEnterarRef.current && radioRetencionPorEnterarRef.current.checked) {
          sql3 = " AND ret_status = '0'"; // Por Enterar
        } else if (radioRetencionEnteradasRef.current && radioRetencionEnteradasRef.current.checked) {
          sql3 = " AND ret_status = '1'"; // Enteradas
        }

        // Combinar todas las condiciones
        let condicionCompleta = sql + banco + sql3;

        // Nombre del reporte Jasper (Adm_FondoRetencPend en Java)
        let fileName = "Adm_FondoRetencPend";

        // Parámetros para el reporte
        let params = {
          reporte: fileName,
          efiscal: idEfi,
          CONDICION: encodeURIComponent(condicionCompleta),
          TIT_RANGO: encodeURIComponent(sql2),
          FECFIN: encodeURIComponent("'" + val3 + "'"),
          tit: encodeURIComponent(tit),
          org: encodeURIComponent(org)
        };

        // Construir URL con parámetros
        let urlParams = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" + urlParams,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 125: Resumen de Retenciones Anuales por Beneficiario (tiporep 24 de Java) ---
    else if (props.reporte === 125) {
      try {
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Validar que se haya seleccionado un proveedor si el modo es 'seleccionar'
        // if (modoProveedor === 'seleccionar' && (!provCodigoRef.current || provCodigoRef.current.value.trim() === "")) {
        //   setMensaje({
        //     mostrar: true,
        //     titulo: "Información",
        //     texto: "Debe seleccionar un proveedor",
        //     icono: "info",
        //   });
        //   return;
        // }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición base de fecha
        let sql = " RET_FECHA Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Condición de proveedor
        if (modoProveedor === 'seleccionar' && provCodigoRef.current && provCodigoRef.current.value.trim() !== "") {
          sql = sql + " AND t.idproveedor = " + provCodigoRef.current.value.trim();
        }

        // Nombre del reporte Jasper (Adm_RetencAnual en Java)
        let fileName = "Adm_RetencAnual";

        // Parámetros para el reporte
        let params = {
          reporte: fileName,
          efiscal: idEfi,
          CONDICION: encodeURIComponent(sql.trim()),
          TIT_RGO1: encodeURIComponent(sql2),
          FECFIN: encodeURIComponent("'" + val3 + "'"),
          tit: encodeURIComponent(tit),
          org: encodeURIComponent(org)
        };

        // Construir URL con parámetros
        let urlParams = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" + urlParams,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- REPORTE 126: Comprobante de Retenciones Varias (tiporep 42 de Java) ---
    else if (props.reporte === 126) {
      try {
        // Validar fechas
        let fDesde = fechaDesdeRef.current.value;
        let fHasta = fechaHastaRef.current.value;

        if (!fDesde || !fHasta) {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe Introducir la Fecha de Inicio y Fin",
            icono: "info",
          });
          return;
        }

        // Validar que se haya seleccionado un proveedor
        if (!provCodigoRef.current || provCodigoRef.current.value.trim() === "") {
          setMensaje({
            mostrar: true,
            titulo: "Información",
            texto: "Debe seleccionar un proveedor",
            icono: "info",
          });
          return;
        }

        // Convertir fechas de YYYY-MM-DD a DD-MM-YYYY (formato que espera el backend)
        let val2 = formatearFecha(fDesde);
        let val3 = formatearFecha(fHasta);

        // Construir condición SQL base (fechas)
        let sql = "fecharet Between" + "'" + val2 + "'" + " AND " + "'" + val3 + "'";

        // Agregar condición de proveedor (exactamente como en Java)
        sql = sql + " AND pro.idproveedor = " + provCodigoRef.current.value.trim();

        // Título para el reporte
        let sql2 = "DESDE EL" + " " + "'" + val2 + "'" + " " + "HASTA EL" + " " + "'" + val3 + "'";

        // Fecha de cierre (31/12/año fiscal actual)
        let anioEfis = idefiscal ? idefiscal.anioejecucion : new Date().getFullYear();
        let cierre = "31/12/" + anioEfis;

        // Nombre del reporte Jasper
        let fileName = "Adm_RetencVarias";
        let tit = titulo[props.reporte] || 'Comprobante de Retenciones Varias';
        let org = post.nombreorg;

        // Parámetros para el reporte
        let params = {
          reporte: fileName,
          EFIS: idefiscal?.idefiscal || idefiscal,
          CONDICION: encodeURIComponent(sql.trim()),
          FECDESDE: encodeURIComponent(val2.trim()),
          FECHASTA: encodeURIComponent(val3.trim()),
          CIERRE: encodeURIComponent(cierre),
          tit: encodeURIComponent(tit),
          org: encodeURIComponent(org)
        };

        // Construir URL con parámetros
        let urlParams = Object.keys(params)
          .map(key => key + "=" + params[key])
          .join("&");

        // Abrir ventana con el reporte
        window.open(
          op.reportes + "/administracionTesoreria?" + urlParams,
          "Planilla",
          "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
        );

      } catch (error) {
        console.error("Error al generar el reporte:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Mensaje de Error: " + error.message,
          icono: "error",
        });
      }
    }

    // --- OTROS REPORTES (los que ya estaban en tu código) ---
    else {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Este reporte aún no está configurado en la función imprimir.",
        icono: "info",
      });
    }
  };

  const onHideCuentaBancaria = (values) => {
    setMostrar(false)
    console.log(values)
    bancoCodigoRef.current.value = values.idcuentabancaria;
    bancoNombreRef.current.value = values.nombre.trim() + ' / ' + values.cuentabancaria;
  }

  const onHideAceptaCatProv = (responsable, razonsocial, idproveedor, rif) => {
    setMostrar2(false)
    console.log(responsable, razonsocial, idproveedor, rif)
    provCodigoRef.current.value = idproveedor
    provNombreRef.current.value = razonsocial + ' ' + rif
  }

  const cerrar = () => {
    props.cancelar();
  };

  const catalogoCat = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleAceptaCatProgramatica = (
    idcategoriaprogramatica,
    descripcion,
    categoriaprogramatica
  ) => {
    setMostrar3(false);

    if (categoriaprogramatica && txt1.current) {
      txt1.current.value = categoriaprogramatica.substring(0, 2);
      txt2.current.value = categoriaprogramatica.substring(2, 4);
      txt3.current.value = categoriaprogramatica.substring(4, 6);
      txt4.current.value = categoriaprogramatica.substring(6, 8);
      txt5.current.value = categoriaprogramatica.substring(8, 10);
    }
  };

  const handleChangeModoProveedor = (nuevoModo) => {
    setModoProveedor(nuevoModo);
    if (nuevoModo === 'todos' && txt1.current) {
      txt1.current.value = '';
      txt2.current.value = '';
      txt3.current.value = '';
      txt4.current.value = '';
      txt5.current.value = '';
    }
  };

  const titulo = {
    120: 'Retenciones Declaradas',
    121: 'Retenciones por Trasladar/Trasladadas a Ctas Fondo de Terceros',
    122: 'Retenciones por Enterar por Proveedor (Fondo de Terceros)',
    123: 'Retenciones Enteradas por Proveedor (Fondo de Terceros)',
    124: 'Retenciones Realizadas - Agrupadas por Bancos',
    125: 'Resumen de Retenciones Anuales por Beneficiario'  ,
    126: 'Comprobante de Retenciones Varias',
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className=" fw-bold text-light m-0">
          {titulo[props.reporte]}
        </h3>
        <button className="btn btn-sm bg-light" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-md-12 row mx-auto px-0">
          {props.reporte === 1 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
              <legend className="float-none text-uppercase w-auto m-0">Tipo de Ordenes</legend>

              <div className="col-md-12 row mx-auto px-0 mb-2">
                <div className="form-check col-md-2 ml-auto">
                  <input
                    ref={checkResumenRef}
                    className="form-check-input text-uppercase"
                    type="checkbox"
                    value=""
                    id="checkDefault"
                  />
                  <label className="form-check-label text-uppercase text-uppercase fw-bold" htmlFor="checkDefault">
                    Resumen
                  </label>
                </div>
              </div>

              <div className="col-md-12 row mx-auto px-0 py-auto">
                <div className="col row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdTodasRef}
                      defaultChecked
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdTodas"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdTodas">
                      Todas
                    </label>
                  </div>
                </div>

                <div className="col row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdPresupRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdPresup"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdPresup">
                      Presupuestarias
                    </label>
                  </div>
                </div>

                <div className="col-md-3 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdFinanRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdFinan"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdFinan">
                      Financieras
                    </label>
                  </div>
                </div>

                <div className="col-md-3 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      ref={radioTipoOrdTercerosRef}
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioTipoOrd"
                      id="radioTipoOrdTerceros"
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioTipoOrdTerceros">
                      Fondo de Terceros
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
            : ''}

          {/* Buscar Por - Siempre visible para reporte 120 */}
          {props.reporte === 120 || props.reporte === 121 || props.reporte === 122 || props.reporte === 123 || props.reporte === 124 || props.reporte === 125 || props.reporte === 126 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded row">
              <legend className="float-none text-uppercase w-auto m-0">Buscar Por</legend>

              <div className="col-md-12 mx-auto row my-auto py-0">
                <div className="input-group input-group-sm col-md-5 mb-0">
                  <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Desde la Fecha:</span>
                  <input
                    ref={fechaDesdeRef}
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={`${anioActual}-01-01`}
                  />
                </div>
                <div className="input-group input-group-sm col-md-5 mb-0">
                  <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Hasta la Fecha:</span>
                  <input
                    ref={fechaHastaRef}
                    type="date"
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    defaultValue={`${fechaHoy}`}

                  />
                </div>
              </div>
            </fieldset>
            : ''}

          {props.reporte === 126 ?
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Proveedor</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                <input
                  ref={provCodigoRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase col-md-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button onClick={() => setMostrar2(true)} type="button" className="btn btn-success"><i className="fas fa-search"></i></button>
                <input
                  ref={provNombreRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </fieldset> : ''}

          {props.reporte === 121 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioProveedorTodasRef}
                    defaultChecked
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioProveedorReporte121"
                    id="radioProveedorTodas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioProveedorTodas">
                    Todas
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioProveedorPorTrasladarRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioProveedorReporte121"
                    id="radioProveedorPorTrasladar"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioProveedorPorTrasladar">
                    Por Trasladar
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioProveedorTrasladadasRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioProveedorReporte121"
                    id="radioProveedorTrasladadas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioProveedorTrasladadas">
                    Trasladadas
                  </label>
                </div>
              </div>
            </div> : ''}

          {props.reporte === 124 ? (
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioBancoSelectRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioBanco"
                    id="radioBancoSelect"
                    checked={modoBanco === 'seleccionar'}
                    onChange={() => setModoBanco('seleccionar')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioBancoSelect">
                    Seleccionar Banco
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioBancoIndividualRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioBanco"
                    id="radioBancoIndividual"
                    checked={modoBanco === 'individual'}
                    onChange={() => setModoBanco('individual')}
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioBancoIndividual">
                    Individual
                  </label>
                </div>
              </div>
            </div>
          ) : ''}

          {/* Inputs de banco */}
          {(props.reporte === 124) && modoBanco === 'seleccionar' ? (
            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none text-uppercase w-auto m-0">Banco</legend>
              <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                <input
                  ref={bancoCodigoRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase col-md-1"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
                <button type="button" onClick={() => { setMostrar(true) }} className="btn btn-success"><i className="fas fa-search"></i></button>

                <input
                  ref={bancoNombreRef}
                  disabled
                  type="text"
                  className="form-control text-uppercase"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>
            </fieldset>
          ) : ''}

          {props.reporte === 124 ?
            <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioRetencionTodasRef}
                    defaultChecked
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioRetencionReporte124"
                    id="radioRetencionTodas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioRetencionTodas">
                    Todas
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioRetencionPorEnterarRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioRetencionReporte124"
                    id="radioRetencionPorEnterar"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioRetencionPorEnterar">
                    Por Enterar
                  </label>
                </div>
              </div>

              <div className="col-md-4 row mx-auto mb-2">
                <div className="form-check my-auto">
                  <input
                    ref={radioRetencionEnteradasRef}
                    className="form-check-input text-uppercase my-auto"
                    type="radio"
                    name="radioRetencionReporte124"
                    id="radioRetencionEnteradas"
                  />
                  <label className="form-check-label text-uppercase my-auto" htmlFor="radioRetencionEnteradas">
                    Enteradas
                  </label>
                </div>
              </div>
            </div> : ''}

          {props.reporte === 121 || props.reporte === 122 || props.reporte === 123 ? (
            <>
              <div className="col-md-12 row mx-auto px-0 pt-2 border py-auto pl-5 mt-2 rounded">
                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioProveedor"
                      id="radioProvSelect"
                      checked={modoProveedor === 'seleccionar'}
                      onChange={() => setModoProveedor('seleccionar')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvSelect">
                      Seleccionar Proveedor
                    </label>
                  </div>
                </div>

                <div className="col-md-4 row mx-auto mb-2">
                  <div className="form-check my-auto">
                    <input
                      className="form-check-input text-uppercase my-auto"
                      type="radio"
                      name="radioProveedor"
                      id="radioProvTodos"
                      checked={modoProveedor === 'todos'}
                      onChange={() => setModoProveedor('todos')}
                    />
                    <label className="form-check-label text-uppercase my-auto" htmlFor="radioProvTodos">
                      Todos
                    </label>
                  </div>
                </div>
              </div>

              {modoProveedor === 'seleccionar' ? (
                <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                  <legend className="float-none text-uppercase w-auto m-0">Proveedor</legend>
                  <div className="input-group input-group-sm col-md-12 mx-auto mb-1">
                    <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Código:</span>
                    <input
                      ref={provCodigoRef}
                      disabled
                      type="text"
                      className="form-control text-uppercase col-md-1"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                    <button onClick={() => setMostrar2(true)} type="button" className="btn btn-success"><i className="fas fa-search"></i></button>
                    <input
                      ref={provNombreRef}
                      disabled
                      type="text"
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </fieldset>
              ) : ''}
            </>
          ) : ''}

          {props.reporte === 121 || props.reporte === 122 || props.reporte === 123 ? (
            <div className="input-group input-group-sm col-md-12 mx-auto mb-1 px-0 mt-2">
              <span className="input-group-text text-uppercase" id="inputGroup-sizing-sm">Tipo de Retención</span>
              <select
                ref={selectTipoRetencionRef}
                className="form-select"
                aria-label="Default select example"
              >
                {tiposRetencion.map((tipo) => (
                  <option key={tipo.idtiporetencion} value={tipo.idtiporetencion}>
                    {tipo.descripcion}
                  </option>
                ))}
              </select>
            </div>
          ) : ''}
        </div>

        <Mensaje
          mensaje={mensaje}
          onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })}
        />

        <CatalogoProveedorPresupuesto
          show={mostrar2}
          onHideCancelar={() => setMostrar2(false)}
          onHideAceptaProveedor={onHideAceptaCatProv}
        />

        <CatalogoCuentaBancaria
          show={mostrar}
          onHideCancelar={() => setMostrar(false)}
          onHideAceptaCatalogo={onHideCuentaBancaria}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-sm btn-primary text-uppercase" onClick={imprimir}>
          <i className="fas fa-print me-2"></i> Imprimir
        </button>
        <button className="btn btn-sm btn-secondary text-uppercase" onClick={cerrar}>
          <i className="fas fa-times me-2"></i> Cancelar
        </button>
      </Modal.Footer>
    </Modal>
  );
};